var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_has.js
// module id = 73
// module chunks = 168707334958949